import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { GlobalStyle } from "../styles";
import { Head, NavBar, Footer } from ".";

const StyledContent = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

const Layout = ({ children }) => {
  return (
    <>
      <Head />
      <div id="root">
        <GlobalStyle />
        <StyledContent>
          <NavBar />
          <div id="content">{children}</div>
          <Footer />
        </StyledContent>
      </div>
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
